import { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { Box, Button, Drawer, IconButton, List, Typography } from "@mui/material";
import { DashboardSidebarItem } from "./dashboard-sidebar-item";
import { Scrollbar } from "./scrollbar";
import { ChevronLeft as ChevronLeftIcon } from "../icons/chevron-left";
import { ChevronRight as ChevronRightIcon } from "../icons/chevron-right";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useAuth } from "../hooks/use-auth";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Person4Icon from "@mui/icons-material/Person4";
import PaymentsIcon from "@mui/icons-material/Payments";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardIcon from "@mui/icons-material/Dashboard";

import {
  Category,
  CurrencyExchange,
  Inventory,
  LocalAtm,
  Storefront,
  BrandingWatermark,
  ReceiptLong,
  PriceCheckSharp,
  MonetizationOn,
  Logout as LogoutIcon
} from "@mui/icons-material";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PublicIcon from "@mui/icons-material/Public";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import AssessmentIcon from "@mui/icons-material/Assessment";
import GavelIcon from "@mui/icons-material/Gavel";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import HistoryIcon from "@mui/icons-material/History";
import EmailIcon from "@mui/icons-material/Email";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ArticleIcon from "@mui/icons-material/Article";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
// const items = [
//   {
//     icon: GroupsIcon,
//     title: "Employees",
//     href: "/dashboard/employees",
//   },
//   {
//     icon: PublicIcon,
//     title: "Departments",
//     href: "/dashboard/department",
//   },
//   {
//     icon: SubscriptionsIcon,
//     title: "Subscriptions",
//     href: "/dashboard/subscriptions",
//   },
//   // {
//   //   icon: BusinessIcon,
//   //   title: 'Brands',
//   //   href: '/dashboard/brands',
//   // },
//   // {
//   //   icon: BusinessIcon,
//   //   title: "Business Accounts",
//   //   href: "/dashboard/business-heads",
//   // },
//   {
//     icon: CurrencyRupeeIcon,
//     title: "Tax Accounts",
//     href: "/dashboard/taxaccounts",
//   },
//   {
//     icon: AttachMoneyIcon,
//     title: "Tax Schemes",
//     href: "/dashboard/taxcode",
//   },
//   {
//     icon: PaymentsIcon,
//     title: "Payment Channels",
//     href: "/dashboard/paymentchannels",
//   },
//   {
//     icon: PaymentIcon,
//     title: "Payment Profile",
//     href: "/dashboard/paymentprofile",
//   },
//   {
//     icon: GroupsIcon,
//     title: "Clients",
//     href: "/dashboard/clients",
//   },
//   {
//     icon: MonetizationOn,
//     title: "Currencies",
//     href: "/dashboard/currencies",
//   },
//    {
//     icon: PublicIcon,
//     title: "Country",
//     href: "/dashboard/country",
//   },

//   {
//     icon: PriceChangeIcon,
//     title: "Transactions",
//     href: "/dashboard/transactions",
//   },
//   {
//     icon: PriceCheckSharp,
//     title: "Transaction Category",
//     href: "/dashboard/transaction-category",
//   },
//   {
//     icon: DescriptionIcon,
//     title: "Business Invoices",
//     href: "/dashboard/business-invoices",
//   },
//   {
//     icon: DescriptionIcon,
//     title: "Business Invoices2",
//     href: "/dashboard/business-invoices2",
//   },
//   {
//     icon: CurrencyExchange,
//     title: "Reimbursement",
//     href: "/dashboard/reimbursement",
//   },
//   {
//     icon: Storefront,
//     title: "Vendors",
//     href: "/dashboard/vendors",
//   },
//   {
//     icon: LocalAtm,
//     title: "Vendors Payment",
//     href: "/dashboard/vendorpayment",
//   },
//   {
//     icon: ReceiptOutlinedIcon,
//     title: "Vendor Bills",
//     href: "/dashboard/vendor-bills",
//   },
//   {
//     icon: ReceiptLong,
//     title: "Vendor Category",
//     href: "/dashboard/vendor-category",
//   },
//   {
//     icon: Inventory,
//     title: "Inventory",
//     href: "/dashboard/inventory",
//   },
//   {
//     icon: Category,
//     title: "Inventory Category",
//     href: "/dashboard/category",
//   },
//   {
//     icon: BrandingWatermark,
//     title: "Inventory Brands",
//     href: "/dashboard/brands",
//   },
//   {
//     icon: AddHomeWork,
//     title: "Work Orders",
//     href: "/dashboard/work-orders",
//   },
//   {
//     icon: AccountBalanceWalletIcon,
//     title: "Ledger",
//     href: "/dashboard/ledger",
//   },
//   {
//     icon: PriceChangeIcon,
//     title: "Internal Invoice",
//     href: "/dashboard/internal-invoice",
//   },

// ];
const items = [
  // 1. Dashboards
  {
    icon: DashboardIcon,
    title: "Dashboards",
    items: [
      { icon: FactCheckOutlinedIcon, title: "Action Dashboard", href: "/dashboard/action" },
      { icon: AssessmentIcon, title: "Financial Summary", href: "/dashboard/main" },
    ],
  },
  // 2. Transactions
  { icon: SwapHorizIcon, title: "Transactions", href: "/dashboard/transactions" },
  // 3. Client Management
  {
    icon: BusinessIcon,
    title: "Client Management",
    items: [
      { icon: BusinessIcon, title: "Clients", href: "/dashboard/clients" },
      { icon: FiberNewIcon, title: "New Clients", href: "/dashboard/clients/new" },
      { icon: ArticleIcon, title: "Contracts", href: "/dashboard/contracts" },
      { icon: RequestQuoteIcon, title: "Quotations Sent", href: "/dashboard/quotations" },
      { icon: RequestQuoteIcon, title: "Quotations Received", href: "/dashboard/quotations-received" },
    ],
  },
  // 4. Invoicing
  {
    icon: ReceiptLongIcon,
    title: "Invoicing",
    items: [
      { icon: ReceiptLongIcon, title: "Invoices", href: "/dashboard/business-invoices" },
      { icon: FactCheckOutlinedIcon, title: "Follow Ups", href: "/dashboard/follow-ups" },
      // The Follow Ups page's existing "Not Send" tab.
      { icon: UnsubscribeIcon, title: "Never Sent", href: "/dashboard/follow-ups?tab=6" },
      // Invoices flagged with Settings → Show Warning.
      { icon: ReportProblemOutlinedIcon, title: "Needs Attention", href: "/dashboard/business-invoices?report=hasWarning" },
      // The invoice listing's Reminder Log, on its "Needs attention" tab.
      { icon: ReportProblemOutlinedIcon, title: "Reminder Issues", href: "/dashboard/business-invoices?view=reminders&reminderTab=attention" },
      { icon: AssignmentReturnIcon, title: "Credit Notes", href: "/dashboard/credit-notes" },
      { icon: AssignmentIcon, title: "Work Orders", href: "/dashboard/work-orders" },
    ],
  },
  // 5. Billing
  {
    icon: ReceiptIcon,
    title: "Billing",
    items: [
      { icon: ReceiptIcon, title: "Bills", href: "/dashboard/bills" },
      { icon: DescriptionIcon, title: "Bill Copies", href: "/dashboard/bill-copies" },
      { icon: PaymentsIcon, title: "Pay Requests", href: "/dashboard/pay-request" },
      { icon: Storefront, title: "Vendors", href: "/dashboard/vendors" },
      { icon: PaymentsIcon, title: "Vendor Requests", href: "/dashboard/vendor-requests" },
      { icon: CurrencyExchange, title: "Reimbursement", href: "/dashboard/reimbursement" },
      { icon: SubscriptionsIcon, title: "Subscriptions", href: "/dashboard/subscriptions" },
    ],
  },
  // 6. Ledger
  { icon: MenuBookIcon, title: "Ledger", href: "/dashboard/ledger" },
  // 7. Payment Profiles
  { icon: AccountBalanceWalletIcon, title: "Payment Profiles", href: "/dashboard/masterdata/paymentprofile" },
  // 8. Notes
  { icon: DescriptionIcon, title: "Notes", href: "/dashboard/client-notes" },
  // 9. Tasks
  { icon: FactCheckOutlinedIcon, title: "Accounting Tasks", href: "/dashboard/accounting-tasks" },
  // 10. Audit Log
  { icon: HistoryIcon, title: "Audit Log", href: "/dashboard/audit" },
  // Reports section
  {
    icon: AssessmentIcon,
    title: "Reports",
    items: [
      { icon: AssessmentIcon, title: "Financial Summary", href: "/dashboard/reports/financial-summary" },
      { icon: AssessmentIcon, title: "Monthly Summary", href: "/dashboard/reports/monthly-summary" },
      { icon: AssessmentIcon, title: "Monthly Sales", href: "/dashboard/reports/monthly-sales" },
      { icon: ReceiptLongIcon, title: "Line Item Report", href: "/dashboard/reports/line-items" },
      { icon: AssessmentIcon, title: "Partner Share", href: "/dashboard/reports/partner-share" },
    ],
  },
  // Tax Returns collapsible section
  {
    icon: AssessmentIcon,
    title: "Tax Returns",
    items: [
      { icon: ListAltIcon, title: "Tax Returns", href: "/dashboard/tax-returns" },
      { icon: ReceiptLongIcon, title: "Invoices", href: "/dashboard/tax-returns/invoices" },
      { icon: ReceiptOutlinedIcon, title: "GSTR-2B", href: "/dashboard/gstr2b" },
    ],
  },
  // Tax collapsible section
  {
    icon: GavelIcon,
    title: "Tax",
    items: [
      { icon: CurrencyRupeeIcon, title: "TDS", href: "/dashboard/tax/tds" },
    ],
  },
  // Bonus collapsible section
  {
    icon: CurrencyRupeeIcon,
    title: "Bonus",
    items: [
      { icon: GroupsIcon, title: "Bonus Members", href: "/dashboard/bonus/members" },
      { icon: ListAltIcon, title: "Bonus Listing", href: "/dashboard/bonus/listing" },
      { icon: ReceiptLongIcon, title: "Assign Bonus", href: "/dashboard/reports/assign-bonus" },
      { icon: ListAltIcon, title: "Invoices with Bonus", href: "/dashboard/reports/invoice-bonuses" },
    ],
  },
  // Purchase Orders (collapsible)
  {
    icon: ShoppingCartIcon,
    title: "Purchase Orders",
    items: [
      { icon: ShoppingCartIcon, title: "Sent", href: "/dashboard/purchase-orders/sent" },
      { icon: ShoppingCartIcon, title: "Received", href: "/dashboard/purchase-orders/received" },
    ],
  },
  // Inventory collapsible section
  {
    icon: Inventory,
    title: "Inventory",
    items: [
      { icon: Inventory, title: "Items", href: "/dashboard/inventory" },
      { icon: Category, title: "Categories", href: "/dashboard/masterdata/category" },
      { icon: Storefront, title: "Vendors", href: "/dashboard/vendors" },
      { icon: BrandingWatermark, title: "Brands", href: "/dashboard/masterdata/brands" },
    ],
  },
  { icon: GroupsIcon, title: "Employees", href: "/dashboard/employees" },
  { icon: Person4Icon, title: "Users", href: "/dashboard/users" },
  // Master Data collapsible section
  {
    icon: BusinessIcon,
    title: "Master Data",
    items: [
      { icon: CurrencyRupeeIcon, title: "Tax Accounts", href: "/dashboard/masterdata/taxaccounts" },
      { icon: AccountBalanceIcon, title: "Payment Channels", href: "/dashboard/masterdata/paymentchannels" },
      { icon: AttachMoneyIcon, title: "Tax Scheme", href: "/dashboard/masterdata/taxscheme" },
      { icon: FactCheckOutlinedIcon, title: "Tax Codes", href: "/dashboard/masterdata/taxcode" },
      { icon: PublicIcon, title: "Countries", href: "/dashboard/masterdata/country" },
      { icon: MonetizationOn, title: "Currencies", href: "/dashboard/masterdata/currencies" },
      { icon: SettingsIcon, title: "Settings", href: "/dashboard/masterdata/settings" },
      { icon: PriceCheckSharp, title: "Transaction Categories", href: "/dashboard/masterdata/transaction-category" },
      { icon: ReceiptLong, title: "Vendor Categories", href: "/dashboard/masterdata/vendor-category" },
      { icon: BusinessIcon, title: "Financial Years", href: "/dashboard/masterdata/financial-years" },
      { icon: ImportExportIcon, title: "Import Formats", href: "/dashboard/masterdata/import-formats" },
      { icon: BusinessIcon, title: "Business Verticals", href: "/dashboard/masterdata/business-verticals" },
      { icon: EmailIcon, title: "Email Templates", href: "/dashboard/masterdata/email-templates" },
      { icon: MiscellaneousServicesIcon, title: "Services", href: "/dashboard/masterdata/services" },
    ],
  },
];

export const DashboardSidebar = (props) => {
  const { onPin, pinned, mobileOpen, onMobileClose } = props;
  const [openedItem, setOpenedItem] = useState(null);
  const [hovered, setHovered] = useState(false);
  const hoverTimeout = useRef(null);
  const location = useLocation();
  const auth = useAuth();

  const handleMouseEnter = useCallback(() => {
    if (!onMobileClose) {
      hoverTimeout.current = setTimeout(() => setHovered(true), 200);
    }
  }, [onMobileClose]);

  const handleMouseLeave = useCallback(() => {
    clearTimeout(hoverTimeout.current);
    if (!onMobileClose) setHovered(false);
  }, [onMobileClose]);

  useEffect(() => {
    return () => clearTimeout(hoverTimeout.current);
  }, []);

  const handleOpenItem = (item) => {
    if (openedItem === item) {
      setOpenedItem(null);
      return;
    }

    setOpenedItem(item);
  };

  // Auto-open parent if a child is active
  useEffect(() => {
    items.forEach((item) => {
      if (item.items) {
        const isChildActive = item.items.some((subItem) => location.pathname === subItem.href);
        if (isChildActive) {
          setOpenedItem(item);
        }
      }
    });
  }, [location.pathname]);

  const logoutHandler = () => {
    auth.logout();
  };

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={onMobileClose ? mobileOpen : true}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant={onMobileClose ? "temporary" : "permanent"}
      PaperProps={{
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        sx: {
          backgroundColor: "background.paper",
          height: "100%",
          overflowX: "hidden",
          transition: "width 250ms cubic-bezier(0.4, 0, 0.2, 1)",
          width: (onMobileClose || pinned || hovered) ? 250 : 73,
          borderRight: (theme) => `1px solid ${theme.palette.divider}`,
          "& .simplebar-content": {
            height: "100%",
          },
        },
      }}
    >
      <Scrollbar
        sx={{
          height: '100%',
          '& .simplebar-content': {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              minHeight: 64,
              overflow: "hidden",
              whiteSpace: "nowrap"
            }}
          >
            <Box
              component="img"
              src="/favicon-sow.png"
              alt="Soul of Work"
              sx={{
                height: 32,
                width: 32,
                objectFit: "contain",
                borderRadius: 1,
                mr: 2,
                flexShrink: 0
              }}
            />
            {(hovered || pinned) && (
              <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 800,
                    color: "text.primary",
                    fontSize: "0.8rem",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    lineHeight: 1.2
                  }}
                >
                  Soul of Work
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 500,
                    color: "text.secondary",
                    fontSize: "0.65rem",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    lineHeight: 1.2
                  }}
                >
                  Accounts
                </Typography>
              </Box>
            )}
          </Box>

          <Box sx={{ flexGrow: 1, overflowY: "auto", px: 2, py: 1 }}>
            <List
              disablePadding
              sx={{ scrollbarWidth: "none" }}
            >
              {items.map((item) => {
                const active = item.href ? location.pathname === item.href : false;

                return (
                  <DashboardSidebarItem
                    key={item.title}
                    onOpen={() => handleOpenItem(item)}
                    open={openedItem?.title === item.title && (hovered || pinned)}
                    pinned={pinned || hovered}
                    active={active}
                    location={location}
                    iconColor="black"
                    {...item}
                  />
                );
              })}
            </List>
          </Box>

          <Box
            sx={{
              p: 2,
              borderTop: (theme) => `1px solid ${theme.palette.divider}`,
              display: "flex",
              flexDirection: "column",
              gap: 1
            }}
          >
            <Button
              fullWidth
              onClick={logoutHandler}
              variant="outlined"
              size="small"
              color="inherit"
              sx={{
                justifyContent: "center",
                minWidth: 0,
                px: (hovered || pinned) ? 2 : 0,
                border: (hovered || pinned) ? undefined : 'none',
                "& .MuiButton-startIcon": {
                  margin: (hovered || pinned) ? undefined : 0
                }
              }}
              startIcon={<LogoutIcon fontSize="small" />}
            >
              {(hovered || pinned) && "Logout"}
            </Button>

            <Box sx={{ display: 'flex', justifyContent: (hovered || pinned) ? 'flex-end' : 'center' }}>
              <IconButton onClick={onPin} size="small">
                {pinned ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Scrollbar>
    </Drawer>
  );
};

DashboardSidebar.propTypes = {
  onPin: PropTypes.func,
  pinned: PropTypes.bool,
};

// { icon: DescriptionIcon, title: "Business Invoices2", href: "/dashboard/business-invoices2" },
// { icon: Storefront, title: "Vendors", href: "/dashboard/vendors" },
// { icon: LocalAtm, title: "Vendors Payment", href: "/dashboard/vendorpayment" },
// { icon: ReceiptOutlinedIcon, title: "Vendor Bills", href: "/dashboard/vendor-bills" },
// { icon: Inventory, title: "Inventory", href: "/dashboard/inventory" },
// { icon: PriceChangeIcon, title: "Internal Invoice", href: "/dashboard/internal-invoice" },
// { icon: PublicIcon, title: "Departments", href: "/dashboard/department" },
//  { icon: DescriptionIcon, title: "Business Invoices", href: "/dashboard/business-invoices" },
